import { type, string, size, optional, union, literal } from 'superstruct';
import { Sale } from '../../core/typescript/sale';
export const ProductDetailsIO = type({
    currencyCode: size(string(), 3, 3),
    moneyFormat: string(),
    sale: Sale,
    collection: optional(union([
        string(),
        literal(null)
    ]))
});
